var _classCallCheck = require("/Users/joshuakim/codesmith/test-repos/calculator/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/joshuakim/codesmith/test-repos/calculator/node_modules/@babel/runtime/helpers/createClass");

/* eslint-disable no-console */

/* eslint-disable no-param-reassign */
// this is the current snapshot that is being sent to the snapshots array.
var Tree =
/*#__PURE__*/
function () {
  "use strict";

  function Tree(component) {
    var useStateInstead = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var name = arguments.length > 2 ? arguments[2] : undefined;

    _classCallCheck(this, Tree);

    // special case when component is root
    // give it a special state = 'root'
    // a setState function that just calls the callback instantly
    if (!useStateInstead) {
      this.component = component === 'root' ? {
        state: 'root',
        setState: function setState(partial, callback) {
          return callback();
        }
      } : component;
    } else {
      this.state = component;
      this.name = name;
    }

    this.children = []; // DEV: Added print() for debugging purposes
    // this.print(); // this call is not useful here. it would be useful in a function call where we've already added to this.children
  }

  _createClass(Tree, [{
    key: "appendChild",
    value: function appendChild(component) {
      var child = new Tree(component);
      this.children.push(child);
      return child;
    } // deep copies only the state of each component and creates a new tree

  }, {
    key: "getCopy",
    value: function getCopy() {
      var copy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Tree('root', true);
      // copy state of children
      copy.children = this.children.map(function (child) {
        return new Tree(child.component.state || child.component.traversed, true, child.component.constructor.name);
      }); // copy children's children recursively

      this.children.forEach(function (child, i) {
        return child.getCopy(copy.children[i]);
      });
      return copy;
    } // print out the tree structure in the console
    // DEV: Process may be different for useState components
    // BUG FIX: Don't print the Router as a component
    // Change how the children are printed

  }, {
    key: "print",
    value: function print() {
      var _console;

      console.log("current tree structure for *this : ", this);
      var children = ['children: ']; // DEV: What should we push instead for components using hooks (it wouldn't be state)

      this.children.forEach(function (child) {
        // if this.children is always initialized to empty array, when would there ever be anything to iterate through here?
        children.push(child.state || child.component.state);
      });
      if (this.name) console.log("this.name if exists: ", this.name);

      if (children.length === 1) {
        console.log("children length 1. ".concat(this.state ? "this.state: " : "this.component.state: "), this.state || this.component.state);
      } else (_console = console).log.apply(_console, ["children length !== 1. ".concat(this.state ? "this.state: " : "this.component.state, children: "), this.state || this.component.state].concat(children));

      this.children.forEach(function (child) {
        child.print();
      });
    }
  }]);

  return Tree;
}();

module.exports = Tree;